"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFrequencyAccountSize = exports.getFrequencyAccountGpaBuilder = exports.safeFetchAllFrequencyAccount = exports.fetchAllFrequencyAccount = exports.safeFetchFrequencyAccount = exports.fetchFrequencyAccount = exports.deserializeFrequencyAccount = exports.getFrequencyAccountAccountDataSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const types_1 = require("../types");
function getFrequencyAccountAccountDataSerializer() {
    return (0, serializers_1.struct)([
        ['key', (0, types_1.getKeySerializer)()],
        ['lastUpdate', (0, serializers_1.i64)()],
        ['period', (0, serializers_1.i64)()],
    ], { description: 'FrequencyAccountAccountData' });
}
exports.getFrequencyAccountAccountDataSerializer = getFrequencyAccountAccountDataSerializer;
function deserializeFrequencyAccount(rawAccount) {
    return (0, umi_1.deserializeAccount)(rawAccount, getFrequencyAccountAccountDataSerializer());
}
exports.deserializeFrequencyAccount = deserializeFrequencyAccount;
async function fetchFrequencyAccount(context, publicKey, options) {
    const maybeAccount = await context.rpc.getAccount((0, umi_1.publicKey)(publicKey, false), options);
    (0, umi_1.assertAccountExists)(maybeAccount, 'FrequencyAccount');
    return deserializeFrequencyAccount(maybeAccount);
}
exports.fetchFrequencyAccount = fetchFrequencyAccount;
async function safeFetchFrequencyAccount(context, publicKey, options) {
    const maybeAccount = await context.rpc.getAccount((0, umi_1.publicKey)(publicKey, false), options);
    return maybeAccount.exists ? deserializeFrequencyAccount(maybeAccount) : null;
}
exports.safeFetchFrequencyAccount = safeFetchFrequencyAccount;
async function fetchAllFrequencyAccount(context, publicKeys, options) {
    const maybeAccounts = await context.rpc.getAccounts(publicKeys.map((key) => (0, umi_1.publicKey)(key, false)), options);
    return maybeAccounts.map((maybeAccount) => {
        (0, umi_1.assertAccountExists)(maybeAccount, 'FrequencyAccount');
        return deserializeFrequencyAccount(maybeAccount);
    });
}
exports.fetchAllFrequencyAccount = fetchAllFrequencyAccount;
async function safeFetchAllFrequencyAccount(context, publicKeys, options) {
    const maybeAccounts = await context.rpc.getAccounts(publicKeys.map((key) => (0, umi_1.publicKey)(key, false)), options);
    return maybeAccounts
        .filter((maybeAccount) => maybeAccount.exists)
        .map((maybeAccount) => deserializeFrequencyAccount(maybeAccount));
}
exports.safeFetchAllFrequencyAccount = safeFetchAllFrequencyAccount;
function getFrequencyAccountGpaBuilder(context) {
    const programId = context.programs.getPublicKey('mplTokenAuthRules', 'auth9SigNpDKz4sJJ1DfCTuZrZNSAgh9sFD3rboVmgg');
    return (0, umi_1.gpaBuilder)(context, programId)
        .registerFields({
        key: [0, (0, types_1.getKeySerializer)()],
        lastUpdate: [1, (0, serializers_1.i64)()],
        period: [9, (0, serializers_1.i64)()],
    })
        .deserializeUsing((account) => deserializeFrequencyAccount(account));
}
exports.getFrequencyAccountGpaBuilder = getFrequencyAccountGpaBuilder;
function getFrequencyAccountSize() {
    return 17;
}
exports.getFrequencyAccountSize = getFrequencyAccountSize;
//# sourceMappingURL=frequencyAccount.js.map